import { Component, OnInit } from "@angular/core";

import { BaseControlComponent } from "../../../../../../../form-controls/components/base-control/base-control.component";
import { ensureWellComponentConfig, WellConfigType, WellConfigurationData, GisContextLocationType } from "../../../../../../../form-controls/components/new-casing-plan/models/casing-plan.model";
import { ContextInteractionService } from "../../../../../../../form-controls/services/context-interaction.service";

@Component({
    selector: "app-casing-plan-data-config",
    templateUrl: "./casing-plan-data-config.component.html",
    styleUrls: ["./casing-plan-data-config.component.scss"],
    standalone: false
})
export class CasingPlanDataConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "CasingPlanDataConfigComponent";

    get multipleEntryOptions(): WellConfigurationData[] {
        return this.componentData.config.wellDataPoints.filter(p => p.locationType === GisContextLocationType.MultipleRead);
    }

    get singleEntryOptions(): WellConfigurationData[] {
        return this.componentData.config.wellDataPoints.filter(p => p.locationType === GisContextLocationType.ReadOnly);
    }    

    visibility = new Map<string, boolean>();

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {        
        this.initializeConfig();
        this.visibility.set("single", false);
        this.visibility.set("multiple", false);
    }

    accordion(section: string) {
        const now = this.sectionIsVisible(section);
        this.visibility.set(section, !now);
        return false;
    }

    addEntry(option: WellConfigurationData) {
        option.multipleLocations.push(" ");
        return false;
    }

    generateMultiId(name: string, index: number): string {
        return `${name}_${index}`;
    }

    initializeConfig(): void {
        this.componentData.config.wellDataPoints = ensureWellComponentConfig(WellConfigType.NewCasingPlan, this.componentData.config.wellDataPoints);
    }    

    sectionIsVisible(section: string): boolean {
        return this.visibility.get(section);
    }    
}
